import { requireModule } from '../../auth/guards';
import { MODULES } from '../../auth/permissions';
import { Navigate, useParams } from 'react-router-dom';
import AddProjectPage from './features/add-project/AddProjectPage';
import ProjectFormPage from './features/project-form/ProjectFormPage';
import AssignWorkPage from './pages/AssignWorkPage';
import QuotationApprovalsPage from './pages/QuotationApprovalsPage';
import ProjectsPage from './pages/ProjectsPage';
import { ProjectViewByRole } from './project-view/pages';
import { WorkJobReportPage } from './reports';
import SiteVisitChecklistsPage from '../site-visits/pages/SiteVisitChecklistsPage';
import SiteVisitDetailPage from '../site-visits/pages/SiteVisitDetailPage';
import SiteVisitsPage from '../site-visits/pages/SiteVisitsPage';

function LegacyJobRedirect() {
  const { id } = useParams();
  return <Navigate to={`/work/projects/${id}`} replace />;
}

export const workRoutes = [
  {
    path: '/work/projects',
    element: <ProjectsPage />,
    handle: { breadcrumb: 'Projects' },
    loader: requireModule(MODULES.PROJECTS),
  },
  {
    path: '/work/projects/new',
    loader: requireModule(MODULES.WORK_JOB_EDIT),
    element: <ProjectFormPage mode='create' />,
  },
  {
    // Gated like the Work Job Report's Edit Job screen, whose fields and save it shares.
    path: '/work/projects/add',
    element: <AddProjectPage />,
    handle: { breadcrumb: 'Add Project' },
    loader: requireModule(MODULES.WORK_JOB_EDIT),
  },
  {
    // V36 — admin only; an approval notification opens it on its quotation (?quote=).
    path: '/work/quotation-approvals',
    element: <QuotationApprovalsPage />,
    handle: { breadcrumb: 'Quotation Approvals' },
    loader: requireModule(MODULES.QUOTATION_APPROVALS),
  },
  {
    path: '/work/report',
    element: <WorkJobReportPage />,
    handle: { breadcrumb: 'Work Job Report' },
    loader: requireModule(MODULES.WORK_JOB_REPORT),
  },
  {
    path: '/work/assign',
    element: <AssignWorkPage />,
    handle: { breadcrumb: 'Assign Work' },
    loader: requireModule(MODULES.ASSIGN_WORK),
  },
  {
    path: '/site-visits',
    element: <SiteVisitsPage />,
    handle: { breadcrumb: 'Site Visits' },
    loader: requireModule(MODULES.SITE_VISITS),
  },
  {
    path: '/work/site-visits/checklists',
    element: <SiteVisitChecklistsPage />,
    handle: { breadcrumb: 'Site Visit Checklists' },
    loader: requireModule(MODULES.SITE_VISITS),
  },
  {
    path: '/work/site-visits/:id',
    element: <SiteVisitDetailPage />,
    handle: { breadcrumb: 'Site Visit' },
    loader: requireModule(MODULES.SITE_VISITS),
  },
  {
    path: '/work/projects/:projectId',
    loader: requireModule(MODULES.PROJECTS),
    element: <ProjectViewByRole />,
  },

  // Old job-detail links (legacy dashboards' job tables) open the project page.
  { path: '/jobs/:id', element: <LegacyJobRedirect /> },

  // {
  //   path: '/work/projects/:projectId/edit',
  //   element: <ProjectFormPage mode='edit' />,
  // },
];
